<template>
  <router-link v-if="this.supervision_type == 'phd'" class="member mb-4 link d-flex flex-column align-items-start" :to=this.path tag="div">
    <!--<div class="thumbnail" v-bind:style="{ 'background-image': 'url(' + '//'+this.url+ this.download_url + ')' }"></div>-->
    <h5 class="mt-1 mb-0">{{ this.member.name }}</h5>
    <span v-if="this.end_date && this.start_date != this.end_date">{{ this.start_date }} - {{ this.end_date }}</span>
    <span v-else-if="this.end_date && this.start_date == this.end_date">{{ this.start_date }}</span>
    <span v-else>{{ this.start_date }} - Present</span>
  </router-link>
  <div v-else class="member mb-4 d-flex flex-column align-items-start">
    <h5 class="mt-1 mb-0">{{ this.member.name }}</h5>
    <span v-if="this.end_date && this.start_date != this.end_date">{{ this.start_date }} - {{ this.end_date }}</span>
    <span v-else-if="this.end_date && this.start_date == this.end_date">{{ this.start_date }}</span>
    <span v-else>{{ this.start_date }} - Present</span>
  </div>
</template>

<script>

export default {
  name: "Supervisee",
  data() {
    return {
        download_url: this.supervision_data.supervisee.photo.download_url,
        title: this.supervision_data.supervisee.photo.title,
        path: '/members/' + this.supervision_data.supervisee.id,
        url: '',
        project_title: this.supervision_data.project_title,
        member: this.supervision_data.supervisee,
        thesis_url: this.supervision_data.thesis_url,
        start_date: this.supervision_data.start_date,
        end_date: this.supervision_data.end_date,
        supervision_type: this.supervision_data.supervision_type
    };
  },
  created() {
    console.log(this.supervision_data)
    this.url = process.env.VUE_APP_API_URL
  },
  props:["supervision_data"]
};

</script>

<style lang="scss">
.member {
  .thumbnail {
    width: 100%;
    padding-bottom: 100%;
    background-size: cover;
    background-position: center;
  }

  h5 {
    font-weight: 500;
    font-size: 1.1em;
    color: black !important;
  }
}

.link {
  cursor: pointer;
}
</style>